// @ts-nocheck


import { EllipsisOutlined } from '@ant-design/icons';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import Button from 'antd/lib/button';
import Menu from 'antd/lib/menu';
import notification from 'antd/lib/notification';
import isEmpty from 'lodash/isEmpty';
import qs from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Section } from '../../../components/layout';
import Header from '../../../components/layout/Header';
import { notificationLoading } from '../../../components/Notifications';
import {
  ButtonsRow,
  Dropdown,
  TabItem,
  Table,
  Tabs } from
'../../../components/ui';


import { setFilter } from '../../../ducks/persistFilters';

import { changeStatus } from './../../../ducks/order';


import { orderApi } from '../../../lib/api';
import {
  accessTypeEnum,
  orderObjectives,
  orderStatuses,
  vehicleGroups,
  orderStatusEnum,
  vehicleTypes } from
'../../../lib/enum';
import {
  formatDateRangeString,
  getListInitialState,
  setQueryParams,
  tooltipFullText } from
'../../../lib/helpers';


import { withUserAccess } from '../../withUserAccess';
import CopyOrderButton from '../components/CopyOrderButton';

import Filter from '../Filter';
import { canCopyOrder, canCancelOrder, canCancelGpmOrder } from '../lib';

export const orderTypes = {
  income: 'income',
  archive: 'archive'
};

export const canAddAccess = [
accessTypeEnum.admin,
accessTypeEnum.adminBranch,
accessTypeEnum.handlingOrder,
accessTypeEnum.creatingOrder];
















export class OrderList extends Component {
  static defaultProps = {
    location: {}
  };

  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };

  canAddOrder = () =>
  this.props.userAccess.some((access) => canAddAccess.includes(access));

  onCancel = async (order) => {
    if (order) {
      try {
        notificationLoading({
          message: 'Сохранение данных...',
          key: 'saving'
        });
        await this.props.changeStatus(order.id, {
          status: orderStatusEnum.cancelled
        });
        notification.success({
          message: 'Заявка успешно отменена'
        });
        await this.fetch();
      } catch (error) {
        notification.error({
          message: error.message
        });
      } finally {
        notification.destroy('saving');
      }
    }
  };

  getColumns = () => {
    const { userAccess, employeeId } = this.props;
    let columns = [
    {
      title: '№',
      dataIndex: 'id',
      sorter: true,
      // Нужно для того, чтобы не отрабатывал onRow
      onCell: () => ({ onClick: (e) => e.stopPropagation() }),
      render: (id) => <Link to={`/orders/${id}/card`}>{id}</Link>
    },
    {
      title: 'Период выделения',
      dataIndex: 'startDate',
      sorterKey: 'route.startDate',
      sorter: true,
      render: (text, record) =>
      formatDateRangeString(record.startDate, record.endDate)
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      sorter: true,
      render: (status) => orderStatuses[status]
    },
    {
      title: 'Служба',
      dataIndex: 'orgUnitName',
      sorterKey: 'node.name',
      sorter: true
    },
    {
      title: 'Примечание',
      dataIndex: 'notation',
      sorter: false,
      render: (notation) => tooltipFullText(notation)
    },
    {
      title: 'Тип',
      dataIndex: 'vehicleType',
      sorter: true,
      render: (text, record) =>
      vehicleTypes[text] || vehicleGroups[record.vehicleGroup]
    },
    {
      title: 'Цель поездки',
      dataIndex: 'objective',
      sorter: true,
      render: (text) => orderObjectives[text]
    }];


    if (this.props.type === orderTypes.archive) {
      columns.splice(2, 0, {
        title: 'Гос. номер',
        dataIndex: 'vehicle',
        render: (vehicle) =>
        vehicle && vehicle.licensePlate ? vehicle.licensePlate : null
      });
    }
    const canCopy = canCopyOrder(this.props.userAccess);
    columns.push({
      title: '',
      width: '30px',
      dataIndex: 'id',
      // Нужно для того, чтобы не отрабатывал onRow
      onCell: () => ({ onClick: (e) => e.stopPropagation() }),
      render: (orderId, order) => {
        const canCancel =
        this.props.type === orderTypes.income && (
        canCancelOrder(order, userAccess, employeeId) ||
        canCancelGpmOrder(order, userAccess));
        return canCopy || canCancel ?
        <Dropdown
          overlay={
          <Menu>
                {canCopy &&
            <Menu.Item>
                    <CopyOrderButton orderId={orderId} />
                  </Menu.Item>
            }
                {canCancel &&
            <Menu.Item onClick={() => this.onCancel(order)}>
                    Отменить заявку
                  </Menu.Item>
            }
              </Menu>
          }>

            <EllipsisOutlined style={{ fontSize: 16, color: '#2770FF' }} />
          </Dropdown> :
        null;
      }
    });

    return columns;
  };

  handleRowClick = (id) => navigate(`/orders/${id}/card`);

  handlePrint = async () => {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath];
    try {
      notificationLoading({
        message: 'Файл для печати формируется',
        key: 'print'
      });
      await orderApi.print(
        {
          ...filter,
          isArchive: this.props.type === orderTypes.archive
        },
        'РеестрЗаявок.xlsx'
      );
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('print');
    }
  };

  fetchOrders = async (
  page = 1,
  params = {}) =>
  {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath] || {};
    this.setState({ loading: true });
    const { data, totalCount } = await orderApi.fetchOrders({
      page,
      isArchive: this.props.type === orderTypes.archive,
      ...filter,
      ...params
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  cleanFilter = async () => {
    await this.setPersistFilter({});
    await this.fetchOrders();
  };

  applyFilter = async (values) => {
    await this.setPersistFilter(values);
    await this.fetchOrders();
  };

  fetch = async () => {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    await this.fetchOrders(page);
  };

  async componentDidMount() {
    await this.fetch();
  }

  render() {
    const { location, userAccess } = this.props;
    const { data, totalCount, pageSize, page, loading, filterPath } =
    this.state;
    const filter = this.props.persistFilters[filterPath];
    const canAdd = this.canAddOrder();
    const handlingOrder = userAccess.includes(accessTypeEnum.handlingOrder);
    return (
      <>
        <Header
          left={<h1>Заявки на транспортные средства</h1>}
          right={
          <ButtonsRow>
              <Button onClick={this.handlePrint}>Печать</Button>
              {canAdd &&
            <Link to="/orders/new">
                  <Button type="primary" data-cy="addOrder">
                    Создать
                  </Button>
                </Link>
            }
            </ButtonsRow>
          } />

        <Tabs withRouter>
          <TabItem url="/orders" label="Входящие заявки" />
          <TabItem url="/orders/archive" label="Архив" />
        </Tabs>
        <Section>
          <Filter
            handlingOrder={handlingOrder}
            mode={this.props.type}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter}
            filter={filter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            loading={loading}
            fetch={this.fetchOrders}
            columns={this.getColumns()}
            customStyle={{
              overflowX: 'auto'
            }}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            data={data.map((item) => ({ ...item, key: item.id }))} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters,
    employeeId: state.auth.profile.employeeId
  }),
  {
    setFilter,
    changeStatus
  }
)(withUserAccess(OrderList));